import { OidcSecure } from '@axa-fr/react-oidc';

const ProtectedRoute = ({ children }) => {
  return <OidcSecure>{children}</OidcSecure>;
};

export default ProtectedRoute;
